export enum EShippingType {
  INTEGRATION = 'INTEGRATION',
  PAID_BY_CUSTOMER = 'PAID_BY_CUSTOMER',
  AVERAGE_BY_ORDER = 'AVERAGE_BY_ORDER',
  LINE_ITEM_QUANTITY = 'LINE_ITEM_QUANTITY',
}

export enum EShippingAmountType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}
